import { render } from "./Section5Manage.vue?vue&type=template&id=69bc7d08&ts=true"
import script from "./Section5Manage.vue?vue&type=script&lang=ts"
export * from "./Section5Manage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__